import { BaseController } from "stimulus-library";

export default class extends BaseController {

  static targets = ['questions', 'question'];
  static values = {
    sortUrl: String,
  };

  connect() {
    if(this.hasQuestionsTarget)
    {
      this.sortable = Sortable.create(
          this.questionsTarget,
          {
            handle: '.question--body',
            draggable: '.question',
            store: {
              get: (_sortable) => [],
              set: (sortable) => this.handleSort(sortable),
            },
            scroll: false,
          },
      );
    }
  }

  disconnect() {
    this.sortable.destroy();
  }

  async shiftDown(e) {
    let target = e.target;
    let node = target.closest('.question');
    if (node.nextElementSibling) {
      node.nextElementSibling.insertAdjacentElement('afterend', node);
      let newOrder = this.questionTargets.map(el => el.dataset.id);
      await this.saveSortOrder(newOrder);
    }
  }

  async shiftUp(e) {
    let target = e.target;
    let node = target.closest('.question');
    if (node.previousElementSibling) {
      node.previousElementSibling.insertAdjacentElement('beforebegin', node);
      let newOrder = this.questionTargets.map(el => el.dataset.id);
      await this.saveSortOrder(newOrder);
    }
  }

  async handleSort(sortable) {
    await this.saveSortOrder(sortable.toArray());
  }

  async saveSortOrder(sortedIds) {
    let payload = new FormData();

    payload.set('authenticity_token', this.csrfToken);
    sortedIds.forEach(val => payload.append('sort_order[]', val));

    let response = await fetch(this.sortUrlValue, {
      method: 'post',
      body: payload,
    });

    if (!response.ok) {
      console.log('Failed');
    }
    // $.post @page.data('sort'), {sort_order: sortable.toArray()}
  }

}